import { useMutation, useQueryClient } from 'react-query';

import { userApi } from 'src/Services/API';
import { ProfilePictureDto, UserWithPrivateInfoDto } from 'src/Services/API/generated';

const useUpdateProfilePicture = () => {
  const queryClient = useQueryClient();

  return useMutation<ProfilePictureDto, unknown, File>(
    async (file: File) => {
      return (await userApi.userControllerUpdateProfilePicture(file)).data;
    },
    {
      onSuccess: data => {
        queryClient.setQueryData<UserWithPrivateInfoDto | undefined>(['fetch-user'], old => {
          if (!old) return old;
          return {
            ...old,
            profilePictureUrl: data.profilePictureUrl,
          };
        });
        queryClient.invalidateQueries(['fetch-user']);
      },
    }
  );
};

export default useUpdateProfilePicture;
